module.exports = __webpack_public_path__ + "static/studs-6b829ba34469300909b871590285fb1f.mp4";